import { Global, css } from '@emotion/react';
import React from 'react';
import type { CSSProperties } from 'react';
import ReactModal from 'react-modal';

import { useTheme } from '../theme';

export interface BaseModalProps
  extends Pick<ReactModal.Props, 'onRequestClose' | 'isOpen'> {
  centered?: boolean;
  padding?: CSSProperties['padding'];
  margin?: CSSProperties['margin'];
  closeButton?: React.ReactNode;
  children: React.ReactNode;
}

export const BaseModal: React.FC<BaseModalProps> = (props) => {
  const {
    componentProperties: { modals },
  } = useTheme();
  return (
    <React.Fragment>
      <Global
        styles={css`
          .BasicModal__Body--open {
            overflow-y: hidden;
          }
          .BasicModal.ReactModal__Content {
            transform: scale(0.9);
            transition: all 0.2s ease;
            opacity: 0;
          }
          .BasicModal.ReactModal__Content--after-open {
            left: 0;
            transform: scale(1);
            opacity: 1;
          }
          .BasicModal.ReactModal__Content--before-close {
            transform: scale(0.9);
            opacity: 0;
          }
          .BasicModal.ReactModal__Content {
            overflow-y: auto;

            @media all and (max-width: 720px) {
              padding: ${props.padding ?? '32px'} !important;
            }
          }
          .OverlayBasicModal {
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 1200;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            overflow-y: auto;
            /* position:  */
            position: fixed;
            top: 0px;
            left: 0px;
            right: 0px;
            bottom: 0px;
          }

          .OverlayBasicModal.ReactModal__Overlay {
            transition: all 0.2s ease;
            opacity: 0;
          }
          .OverlayBasicModal.ReactModal__Overlay--after-open {
            opacity: 1;
          }
          .OverlayBasicModal.ReactModal__Overlay--before-close {
            opacity: 0;
          }
        `}
      />
      <ReactModal
        bodyOpenClassName="BasicModal__Body--open"
        className="BasicModal"
        overlayClassName="OverlayBasicModal"
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        isOpen={props.isOpen}
        onRequestClose={props.onRequestClose}
        closeTimeoutMS={200}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.50)',
            zIndex: 1200,
            display: 'flex',
            justifyContent: 'center',
            alignItems: props.centered ? 'center' : 'flex-start',
            overflowY: 'auto',
            ...modals?.overlay,
          },
          content: {
            borderRadius: 0,
            border: 'none',
            padding: props.padding ?? 0,
            margin: props.margin ?? '0 24px',
            width: 'auto',
            height: 'auto',
            position: 'relative',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            backgroundColor: 'white',
            outline: 'none',
          },
        }}
      >
        {props.closeButton && (
          <div
            css={{
              position: 'absolute',
              insetInlineEnd: '26px',
              top: '32px',
              zIndex: 1000,
              cursor: 'pointer',
            }}
            onClick={props.onRequestClose}
          >
            {props.closeButton}
          </div>
        )}
        {props.children}
      </ReactModal>
    </React.Fragment>
  );
};
